"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcButton_1 = __importDefault(require("../button/AcButton"));
var PdfEditorProvider_1 = require("./PdfEditorProvider");
exports.PdfEditorRotateButtons = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'button' : _b;
    var _c = PdfEditorProvider_1.usePdfEditorContext(), rotateLeft = _c.rotateLeft, rotateRight = _c.rotateRight;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        type === 'button' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AcButton_1.default, { variant: "link", className: "my-1 p-0", width: "45", height: "45", onClick: function () {
                    rotateLeft();
                } },
                react_1.default.createElement("i", { className: "fas fa-undo fs-18 text-secondary" })),
            react_1.default.createElement(AcButton_1.default, { variant: "link", className: "my-1 p-0", width: "45", height: "45", onClick: function () {
                    rotateRight();
                } },
                react_1.default.createElement("i", { className: "fas fa-redo fs-18 text-secondary" })))),
        type === 'link' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "p-0 btn text-white px-1 ml-2", onClick: function () {
                    rotateLeft();
                } },
                react_1.default.createElement("i", { className: "fas fa-undo fs-16" })),
            react_1.default.createElement("span", { className: "p-0 btn text-white px-1 ml-2", onClick: function () {
                    rotateRight();
                } },
                react_1.default.createElement("i", { className: "fas fa-redo fs-16" }))))));
};
exports.PdfEditorRotateButtons.displayName = 'PdfEditorRotateButtons';
//# sourceMappingURL=PdfEditorRotateButtons.js.map